import { SyncIndicator } from "@internal/ui";
import { useObservable } from "@/hooks/useObservable";
import { syncState$ } from "@/lib/replication";

export function SyncStatus() {
  const { connection, pending, lastInSyncAt } = useObservable(syncState$, {
    connection: "connected" as const,
    pending: false,
    lastInSyncAt: null,
  });

  return (
    <SyncIndicator
      connection={connection}
      pending={pending}
      lastInSyncAt={lastInSyncAt}
      data-testid="sync-indicator"
    />
  );
}
